/* eslint-disable import/no-default-export */
import {CartController} from './CartController';
import {controllerFactory as oldControllerFactory} from '@wix/wixstores-client-storefront-sdk';
import {conditionalController} from '../../domain/controllers/conditionalController';
import {controllerFactory} from '../../domain/controllers/controllerFactory';
import {SPECS} from '../../domain/specs';
import {ControllerConstructorType} from '../../types/app.types';

export const conditionalCartControllerFactory = (controller: ControllerConstructorType<CartController>) =>
  conditionalController(
    SPECS.UseNewControllerFactoryInCart,
    controllerFactory(controller, {shouldCallAppSettingsWhenNeeded: true}),
    oldControllerFactory(controller, {shouldCallAppSettingsOnlyWhenMultilingualIsNeeded: true})
  );

export default conditionalCartControllerFactory(CartController);
